<div class="flex justify-between mb-4">
  <div class="text-xl text-gray-700 font-bold">Cotação Fornecedor</div>
</div>
<div>
  <mat-tab-group (selectedIndexChange)="onTabChange($event)">
    <mat-tab label="Cotação Fornecedor">
      <div class="mt-4">
        <mat-accordion>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title> Pesquisa </mat-panel-title>
            </mat-expansion-panel-header>
            <div>
              <form-search-quote-tg
                [search]="inputSearch"
                (responseSearch)="search($event)"
              />
            </div>
          </mat-expansion-panel>
        </mat-accordion>

        <div class="mt-6">
          @if (!loading) {
            <div>
              <table-list-purchases-quote-supplier-page
                [spinLoad]="spinLoad"
                [dataSource]="itemsList"
                [columns]="columns"
                (viewItem)="viewItem($event)"
              />
              @if (itemsList.length > 0) {
                <mat-paginator
                  [length]="numberRows"
                  [pageSize]="rows"
                  [pageIndex]="page - 1"
                  [pageSizeOptions]="[5, 10, 20, 30]"
                  (page)="onPageEvent($event)"
                >
                </mat-paginator>
              }
            </div>
          } @else {
            <div>
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </div>
          }
        </div>
      </div>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <span>Solicitação de Desconto</span>
        @if (discountPendingCount > 0) {
          <span
            class="ml-2 inline-flex items-center justify-center rounded-full bg-red-500 text-white text-xs font-bold min-w-5 h-5 px-1.5"
            [matTooltip]="
              discountPendingCount === 1
                ? '1 solicitação de desconto pendente'
                : discountPendingCount + ' solicitações de desconto pendentes'
            "
          >
            {{ discountPendingCount }}
          </span>
        }
      </ng-template>
      <div class="mt-6">
        @if (!discountLoading) {
          <div>
            <table-list-purchases-quote-supplier-page
              [spinLoad]="spinLoad"
              [dataSource]="discountList"
              [columns]="discountColumns"
              (viewItem)="viewDiscountItem($event)"
            />
            @if (discountList.length > 0) {
              <mat-paginator
                [length]="discountNumberRows"
                [pageSize]="discountRows"
                [pageIndex]="discountPage - 1"
                [pageSizeOptions]="[5, 10, 20, 30]"
                (page)="onDiscountPageEvent($event)"
              >
              </mat-paginator>
            }
          </div>
        } @else {
          <div>
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          </div>
        }
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
